module.exports = __webpack_public_path__ + "static/media/puff.5b8eb5f6.svg";